// Format an integer amount as Thai baht: 1250 → "฿1,250".
// No decimals, comma separator. Used everywhere customer-facing money shows
// up in the widget.

export const formatBaht = (amount) => {
  if (typeof amount !== 'number' || !Number.isFinite(amount)) return '฿0';
  return `฿${Math.round(amount).toLocaleString('en-US')}`;
};

export const formatTimeRange = (start, end) => {
  return `${start} – ${end}`;
};

// Map the day-of-week number returned by Date#getDay (0 = Sunday) to the
// same 3-letter codes the schedule templates use.
const DOW = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

export const dowCode = (date) => DOW[date.getDay()];

export const formatIsoDate = (d) => {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

export const todayIso = () => formatIsoDate(new Date());

export const plusDaysIso = (n) => {
  const d = new Date();
  d.setDate(d.getDate() + n);
  return formatIsoDate(d);
};
